const quizData = [
    {
      question: "Your ideal weekend looks like",
      options: ["Cozy indoors", "Nature walk", "Beach escape", "Art museum", "Cafe hopping", "Spa day"],
      values: ["A", "B", "C", "D", "E", "F"],
      images: ["https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_CozyIndoor.png?v=1764833192", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_NatureWalk.png?v=1764833260", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_BeachEscape.png?v=1764833249", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_ArtMuseum.png?v=1764833219", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_CafeHopping.png?v=1764833205", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_SpaDay.png?v=1764833233"],
    },
    {
      question: "Your personality in 2 words",
      options: ["Nurturing, warm", "Focused, grounded", "Refreshing, bold", "Playful, radiant", "Gentle, kind", "Peaceful, composed"],
      values: ["A", "B", "C", "D", "E", "F"],
      images: ["https://cdn.shopify.com/s/files/1/0784/3207/6065/files/Quiz_Nurturing.png?v=1765173415", 
        "https://cdn.shopify.com/s/files/1/0784/3207/6065/files/Quiz_Focused.png?v=1765173415", 
        "https://cdn.shopify.com/s/files/1/0784/3207/6065/files/Quiz_Refreshing.png?v=1765173414", 
        "https://cdn.shopify.com/s/files/1/0784/3207/6065/files/Quiz_Playful.png?v=1765173415", 
        "https://cdn.shopify.com/s/files/1/0784/3207/6065/files/Quiz_Gentle.png?v=1765173415", 
        "https://cdn.shopify.com/s/files/1/0784/3207/6065/files/Quiz_Peaceful.png?v=1765173415"]
    },
    {
      question: "Your interior vibe",
      options: ["Earthy boho", "Minimalist zen", "Tropical resort", "Colourful modern", "Soft romantic", "Luxe neutral"],
      values: ["A", "B", "C", "D", "E", "F"],
      images: ["https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Earthy.png?v=1764833432", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Minimalist.png?v=1764833365", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Tropical.png?v=1764833390", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Colorful.png?v=1764833415", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Soft.png?v=1764833403", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Luxe.png?v=1764833463"]
    },
    {
      question: "Pick a texture",
      options: ["Velvet", "Linen", "Cold marble", "Citrus peel", "Rose petals", "Cloud"],
      values: ["A", "B", "C", "D", "E", "F"],
      images: ["https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Velvet.png?v=1764833638", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Linen.png?v=1764833651", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Marble.png?v=1764833699", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Citrus.png?v=1764833683", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Rose.png?v=1764833714", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Cloud.png?v=1764833667"]
    },
    {
      question: "Favorite season",
      options: ["Autumn", "Spring", "Summer", "Late summer", "Winter", "Early spring"],
      values: ["A", "B", "C", "D", "E", "F"],
      images: ["https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Autumn.png?v=1764834132", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Spring.png?v=1764834151", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Summer.png?v=1764834066", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_LateSummer.png?v=1764834092", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_Winter.png?v=1764834110", 
        "https://cdn.shopify.com/s/files/1/0634/6139/2451/files/Quiz_EarlySpring.png?v=1764834047"]
    }
  ];

  const quizAnswer = [
    {
      option: ["A", "B", "C", "D", "E", "F"],
      id: ["welcoming", "concentration", "refreshing", "uplifting", "calming", "relaxation"]
    }
  ]
  
  const questionElement = document.getElementById("question");
  const optionsElement = document.getElementById("options");
  const valuesElement = document.getElementById("values");
  const imagesElement = document.getElementById("images");

  const className = "hide-card";

  const welcomingResultElement = document.getElementById("resultWelcoming");
  const refreshingResultElement = document.getElementById("resultRefreshing");
  const concentrationResultElement = document.getElementById("resultConcentration");
  const calmingResultElement = document.getElementById("resultCalming");
  const upliftingResultElement = document.getElementById("resultUplifting");
  const relaxationResultElement = document.getElementById("resultRelaxation");

  let selectedOptions = [];
  let currentQuestion = 0;
  
  function showQuestion() {
    const question = quizData[currentQuestion];
    questionElement.innerText = question.question;
  
    optionsElement.innerHTML = "";
    question.options.forEach(function(option, index) {
      const buttonText = document.createElement("p");
      buttonText.classList.add("options-text"); 
      buttonText.appendChild(document.createTextNode(option));

      const button = document.createElement("button");
      const image = img_create(quizData[currentQuestion].images[index], option, option)
      
      button.appendChild(buttonText);
      button.classList.add("options-button"); 
      button.appendChild(image);
      optionsElement.appendChild(button);
      
      button.addEventListener("click", selectAnswer);
    });
  }
  
  function selectAnswer(e) {
    const selectedButton = e.target;
    const selectedText = selectedButton.innerText != "" ? selectedButton.innerText : selectedButton.title;
    const maxLength = quizData[currentQuestion].options.length;
    for (let i = 0; i <= maxLength; i++) {
        if (selectedText == quizData[currentQuestion].options[i]){
            selectedOptions.push(quizData[currentQuestion].values[i])
        }
    }
    
    currentQuestion++;
  
    if (currentQuestion < quizData.length) {
      showQuestion();
    } else {
      showResult();
    }
  }
  
  function showResult() {
    //debugger;
    quiz.style.display = 'none';
    result.style.display = 'grid';

    const answer = getHighestDuplicateValue(selectedOptions);
    const answerIndex = quizAnswer[0].option;
    const scentResult = quizAnswer[0].id[answerIndex.indexOf(answer)];
    //document.getElementById("resultList").innerHTML = selectedOptions.join(", ");
    //document.getElementById("scentResult").innerHTML = scentResult;
    showProductCard(scentResult);
  }

  function showProductCard(scentName){
    if (scentName.includes("welcoming")){
      welcomingResultElement.classList.remove(className);
    }else if (scentName.includes("refreshing")){
      refreshingResultElement.classList.remove(className);
    }else if (scentName.includes("concentration")){
      concentrationResultElement.classList.remove(className);
    }else if (scentName.includes("calming")){
      calmingResultElement.classList.remove(className);
    }else if (scentName.includes("uplifting")){
      upliftingResultElement.classList.remove(className);
    }else if (scentName.includes("relaxation")){
      relaxationResultElement.classList.remove(className);
    }
  }

  function restartQuiz(){
    quiz.style.display = 'block';
    result.style.display = 'none';
    currentQuestion = 0;
    selectedOptions = [];
    resetProductCardVisibility();
    showQuestion();
  }

  function img_create(src, alt, title) {
    var img = document.createElement('img');
    img.src = src;
    img.classList.add('options-image');
    if ( alt != null ) img.alt = alt;
    if ( title != null ) img.title = title;
    return img;
  } 


  function getHighestDuplicateValue(arr) {
    const counts = {};
    let maxCount = 0;
    let highestDuplicateValue = null;

    for (const item of arr) {
      counts[item] = (counts[item] || 0) + 1; // Increment count for the current item

      if (counts[item] > maxCount) {
        maxCount = counts[item];
        highestDuplicateValue = item;
      }
    }

    // If no duplicates are found (all counts are 1), return null or handle as needed
    if (maxCount === 1 && arr.length > 0) {
      return null; // Or you could return the first element, or throw an error
    }

    return highestDuplicateValue;
  }

  function resetProductCardVisibility(){
    if (!welcomingResultElement.classList.contains(className)){
      welcomingResultElement.classList.add(className);
    }
    if (!refreshingResultElement.classList.contains(className)){
      refreshingResultElement.classList.add(className);
    }
    if (!concentrationResultElement.classList.contains(className)){
      concentrationResultElement.classList.add(className);
    }
    if (!calmingResultElement.classList.contains(className)){
      calmingResultElement.classList.add(className);
    }
    if (!upliftingResultElement.classList.contains(className)){
      upliftingResultElement.classList.add(className);
    }
    if (!relaxationResultElement.classList.contains(className)){
      relaxationResultElement.classList.add(className);
    }
  }

  /*
  async function renderProductCard(productHandle, containerId) {
    debugger;
    const product = await fetchProductData(productHandle);
    if (product) {
        const productCard = createProductCard(product);
        document.getElementById(containerId).appendChild(productCard);
    } else {
        console.error(`Product with handle "${productHandle}" not found.`);
    }
  }

  function createProductCard(product) {
    const card = document.createElement('div');
    card.classList.add('product-card'); // Add a class for styling

    /*
    const image = document.createElement('img');
    image.src = product.featured_image;
    image.alt = product.title;
    card.appendChild(image);

    const title = document.createElement('h3');
    title.textContent = product.title;
    card.appendChild(title);

    const price = document.createElement('p');
    price.textContent = `$${product.price / 100}`; // Prices are in cents
    card.appendChild(price);

    // Add more elements as needed (e.g., description, add to cart button)
    
    return card;
  }

  async function fetchProductData(productHandle) {
    const response = await fetch(`/products/${productHandle}.js`);
    const product = await response.json();
    debugger;
    return product;
  }
  */
  
showQuestion();
